import React, {useEffect, useState} from "react";

import {useDispatch, useSelector} from "react-redux";
import {makeStyles} from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
// import ReactPivot from "react-pivot";
import PivotTableUI from 'react-pivottable/PivotTableUI';
import 'react-pivottable/pivottable.css';
import MaterialTable from "material-table";
import {tableIcons} from "../../../utils/utils";
import {convertISODateTimeToTz} from "../../../common/Util";
import matchSorter from "match-sorter";

const useStyles = makeStyles(theme => ({
    dashboardSection: {
        // padding: "5px"
    },
}));


const ListaOSHeaderCount = ({
                     rows
                          }) => {
    const classes = useStyles();

    const [show, setShow] = useState(false);
    const st = useSelector(state => state);
    console.log("REDUX STATE", st);
    const etapas = useSelector(state => state.stations.etapas);
    const periodMin = useSelector(state => state.filter.periodMin);
    const periodMax = useSelector(state => state.filter.periodMax);

    const dispatch = useDispatch();

    var result = [];


 //   console.log("DADOS PRA REDUZIR",rows);
    if (rows && Array.isArray(rows)) {
        rows.reduce(function (res, value) {
            var key = value.medida + "-" + value.banda + "-" + value.largura;
            //console.log(key);
            if (!res[key]) {
                //   console.log("nao existe chave ", key)
                res[key] = {
                    medida: value.medida,
                    banda: value.banda,
                    largura: value.largura,
                    qtde: 0
                };
                result.push(res[key])
            }
            //   console.log("somando a key ", key, value.QtdeCiclos,  res[key]);
            res[key].qtde += 1;
            return res;
        }, {});
    }

  //  console.log("result reduce",result);
    const getColumns = () => {
        return [

            {
                title: 'Medida',
                id: 'medida',
                field: 'medida',
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, {keys: ["medida"]}),
                filterAll: true,
                minWidth: 150,
                maxWidth: 150
            },
            {
                title: 'Banda',
                id: 'banda',
                field: 'banda',
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, {keys: ["banda"]}),
                filterAll: true,
                minWidth: 150,
                maxWidth: 150
            },
            {
                title: 'Largura',
                id: 'largura',
                field: 'largura',
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, {keys: ["largura"]}),
                filterAll: true,
                minWidth: 50,
                maxWidth: 50
            },
            {
                title: 'Quantidade',
                id: 'qtde',
                field: 'qtde',
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, {keys: ["qtde"]}),
                filterAll: true,
                minWidth: 50,
                maxWidth: 50
            }
        ];
    }





    return (
        <React.Fragment>
            <Grid>
                <Paper>
                    <MaterialTable
                        icons={tableIcons}
                        columns={getColumns()}
                        data={result}
                        title='O.S. por medida, banda e largura'
                        options={{
                            filtering: true,
                            pageSize: 15,
                            pageSizeOptions: [10,25,50,100,200],
                        }}
                        // onRowClick={ (e, data) => {
                        //     console.log("row click", e);
                        //     console.log("row click data", data);
                        //     alert(e, false, data.os)
                        // }}
                    />

                </Paper>
            </Grid>
        </React.Fragment>
    )

}

export default ListaOSHeaderCount;
